// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"2effcfa3","691":"2ae34270","813":"5bcfb717","825":"67358169"}[chunkId] + ".chunk.css";
};